import { Button } from "react-admin";

import { Icon } from "../icons";

type SaveButtonProps = {
  "data-testid"?: string;
  disabled?: boolean;
};

export const SaveButton: React.FC<SaveButtonProps> = ({ "data-testid": dataTestId = "save-button", disabled }) => (
  <Button type="submit" label={"ra.action.save"} variant="contained" data-testid={dataTestId} disabled={disabled}>
    <Icon type="save" size="medium" />
  </Button>
);
